import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { getRegisterEmail, resendConfirmationEmail } from '../slices/userConfirmationSlice'
import Message from '../components/Message'
import Loader from '../components/Loader'
import Alert from 'react-bootstrap/Alert'
import { Button, Form } from 'react-bootstrap'
import ReCAPTCHA from 'react-google-recaptcha'

const RegisterConfirmationScreen = ({ location}) => {
  const [show, setShow] = useState(false)
  const [showa, setShowa] = useState(false)
  const { token } = useParams()
  const dispatch = useDispatch()

  // Use RTK slice state
  const { loading, error, email, resendLoading, resendSuccess } = useSelector((state) => state.userConfirmation)

  const redirect = location.search ? location.search.split('=')[1] : '/'

  const [grecaptcha, setGrecaptcha] = useState(null)
  // Countdown state and persistence key
  const COOLDOWN_SECONDS = 40
  const RESEND_COOLDOWN_KEY = 'register_resend_cooldown_endsAt'
  const [countdownSeconds, setCountdownSeconds] = useState(0)

  const onChange = (value) => {
    setGrecaptcha(value)
  }

  // Restore countdown from localStorage on mount
  useEffect(() => {
    const endsAt = parseInt(localStorage.getItem(RESEND_COOLDOWN_KEY) || '0', 10)
    if (endsAt > Date.now()) {
      const remaining = Math.ceil((endsAt - Date.now()) / 1000)
      setCountdownSeconds(remaining)
    }
  }, [])

  // Tick countdown every second while active
  useEffect(() => {
    if (countdownSeconds <= 0) return
    const id = setInterval(() => {
      const endsAt = parseInt(localStorage.getItem(RESEND_COOLDOWN_KEY) || '0', 10)
      const remaining = Math.max(0, Math.ceil((endsAt - Date.now()) / 1000))
      setCountdownSeconds(remaining)
      if (remaining <= 0) {
        localStorage.removeItem(RESEND_COOLDOWN_KEY)
      }
    }, 1000)
    return () => clearInterval(id)
  }, [countdownSeconds])

  useEffect(() => {
    if (token) {
      dispatch(getRegisterEmail(token))
    }
  }, [dispatch, token])

  useEffect(() => {
    if (error && window?.grecaptcha?.reset) {
      window.grecaptcha.reset()
    }
  }, [error])

  useEffect(() => {
    if (resendSuccess) {
      setShow(true)
      setShowa(false)
      // Start countdown and persist end time
      const endsAt = Date.now() + COOLDOWN_SECONDS * 1000
      localStorage.setItem(RESEND_COOLDOWN_KEY, String(endsAt))
      setCountdownSeconds(COOLDOWN_SECONDS)
    }
  }, [resendSuccess])

  const handleSendEmail = () => {
    // Prevent resend during countdown or while loading
    if (countdownSeconds > 0 || resendLoading) return
    if (!grecaptcha) {
      setShow(false)
      setShowa(true)
      return
    }
    if (email) {
      dispatch(resendConfirmationEmail({ email, grecaptcha }))
    }
  }

  return (
    <>
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <>
          <h1>Thanks For Signing Up!</h1>
          <p>Yay!! You have signed up for the Handshake store!</p>
          <div></div>
          <p>You should be receiving an email from us for you to confirm your account with us. After confirming you should be all set to login. ^___^</p>
          <div></div>
          <Alert show={showa} variant='danger'>
            <Alert.Heading>PLEASE USE ReCAPTCHA!</Alert.Heading>
            <Button onClick={() => setShowa(false)} variant='outline-success'>
              OK
            </Button>
          </Alert>

          <Alert show={show} variant='success'>
            <Alert.Heading>EMAIL SENT!</Alert.Heading>
            <Button onClick={() => setShow(false)} variant='outline-success' className='text-white'>
              OK
            </Button>
          </Alert>

          <div className='d-flex justify-content-end'></div>

          <div>
            <Form.Group className='mb-3' controlId='recaptcha'>
              <ReCAPTCHA
                controlId='grecaptcha'
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''}
                onChange={onChange}
              />
            </Form.Group>
          </div>

          {/* Resend with countdown and disabled state */}
          <Button
            variant='link'
            type='button'
            onClick={handleSendEmail}
            disabled={resendLoading || countdownSeconds > 0}
          >
            {resendLoading
              ? 'Sending…'
              : countdownSeconds > 0
                ? `Resend in ${countdownSeconds}s`
                : 'Resend Confirmation Email'}
          </Button>

          <div className='mt-3'>
            <Link to={redirect ? `/login?redirect=${redirect}` : '/login'}>
              Go to Login
            </Link>
          </div>
        </>
      )}
    </>
  )
}

export default RegisterConfirmationScreen